export enum DateGap {
  Day = '1 DAYS',
  Week = 'WEEK',
  Month = '1 MONTHS',
  Year = 'YEAR',
}

export enum DateFormats {
  '1 DAYS' = 'P',
  'WEEK' = 'dd MMM yyyy',
  '1 MONTHS' = 'MMMM yyyy',
  MonYear = 'MMM yyyy',
  YEAR = 'yyyy',
}

export const getUTCDate = (dateString: string) => new Date(`${dateString.replace(' ', 'T')}Z`);
